<template>
    <b-modal id="editModal" ref="modal" :title="title" @hide="onHide" @cancel="onCancel" :centered="true" :visible="open" :ok-title="okTitle"
     :cancel-title="$t('general.cancel')" :size="size" @ok="saveModal" :ok-disabled="disabled"  :static="true" :scrollable="true">
            <component v-bind:is="renderModalForm" :save="saveAct" :data="modalProps" :changeVal="changeDisabled" :changeData="changeData" 
            :saveState="saveState" :modalName="modalName" :modalEvent="modalEvent" :formName="form"></component>
    </b-modal>
</template>

<script>
    import Address from "./Address"
    import AlarmSystem from "./AlarmSystem"
    import SignalProtocol from "./Protocol"
    import SubEvent from "./SubEvent"
    import SubEventForm from "./SubEventForm"
    //  SubEventForm için componentteki sub event name değişecek
    import Groups from "./SignalGroupsForm"
    import SignalDesc from "./SignalDescriptionForm"
    import NoteType from "./NoteTypeForm"
    import ZoneType from "./ZoneTypeForm"
    import EvaluationResult from "./EvaluationResultForm"
    import QuickNote from "./QuickNoteForm"
    import Job from "./JobForm"
    import AccountType from "./AccountType"
    import Delete from "./Delete"
    import Subscriptions from "./Subscriptions"
    import Brand from "./Panel"
    import Task from "./Task"
    import Menus from "./Menus"
    import Products from "./ProductsForm"
    import Vacations from "./VacationsForm"
    import VacationsJobs from "./VacationsJobsForm.vue"
    import ImportantNumber from "./ImportantNumberForm"
    import StockMovementType from "./StockMovementTypeForm"
    import FaultSupportPieces from "./FaultSupportPiecesForm"
    import FaultSupportResults from "./FaultSupportResults"
    import SignalProtocolsEventCode from "./SignalProtocolsEventCodeForm"
    import SetStateProduct from "./SetStateProduct"
    import Receivers from "./Receivers"
    import ReceiverFormat from "./ReceiverFormat"
    import ReceiverProtocol from "./ReceiverProtocol"
    import ReceiverFormatCopy from "./ReceiverFormatCopy"
    import ADFilter from "./ADFilter"
    import Model from "./Model"

    import CustomField from "./CustomField"
    import i18n from '@/plugins/i18n';

    export default {
        name: 'Modal',
        data: function(){
            return{
                title: '',
                okTitle: i18n.t('general.save'),
                disabled: false,
                saveAct: false,
                size: 'lg'
            }
        },
        props:{
            open: Boolean,
            modalEvent: Function,
            form: String,
            modalName: String,
            modalProps: Object
        },
        components:{
            Address, Delete, AlarmSystem, SignalProtocol, SubEvent, SubEventForm, Groups, SignalDesc, NoteType, ZoneType, EvaluationResult, QuickNote, 
            Job, Subscriptions, AccountType, Brand, Task, Menus, Products, Vacations, ImportantNumber, StockMovementType, FaultSupportPieces,
            VacationsJobs, SignalProtocolsEventCode, SetStateProduct, CustomField, FaultSupportResults, Receivers, ReceiverFormat, ReceiverProtocol,
            ReceiverFormatCopy, ADFilter, Model
        },
        computed:{
            //Açılacak Modalı belirleme işlemleri
            renderModalForm: function(){
                console.log(this.modalProps)
                this.size= 'lg';
               if(this.modalName === "add"){
                    this.title = i18n.t('general.add')
                    this.okTitle = i18n.t('general.add')
                    return this.form
               } else if (this.modalName === "edit"){
                    this.title = i18n.t('general.edit')
                    this.okTitle = i18n.t('general.edit')
                    return this.form
               } else if (this.modalName === "delete"){
                    this.title = i18n.t('general.delete')
                    this.okTitle = i18n.t('general.delete')
                    return "Delete"
               } else if (this.modalName === "setState"){
                    this.title = this.modalProps && this.modalProps.name
                    this.okTitle= i18n.t('general.save')
                    return "SetStateProduct"
                } else if (this.modalName === "addEventCode"){
                    this.title = i18n.t('general.add')
                    this.okTitle = i18n.t('general.add')
                    return "SignalProtocolsEventCode"
                } else if (this.modalName === "editEventCode"){
                    this.title = i18n.t('general.edit')
                    this.okTitle = i18n.t('general.edit')
                    return "SignalProtocolsEventCode"
                } else if (this.modalName === "editFormat"){
                    this.title = i18n.t('general.edit')
                    this.okTitle = i18n.t('general.edit')
                    return "ReceiverFormat"
                } else if (this.modalName === "addFormat"){
                    this.title = i18n.t('general.add')
                    this.okTitle = i18n.t('general.add')
                    return "ReceiverFormat"
                }else if (this.modalName === "copyProtocol"){
                    this.title = i18n.t('general.add')
                    this.okTitle = i18n.t('general.add')
                    return "ReceiverFormatCopy"
                }
            }
        },
        methods:{
            onHide: function(){
                if(!this.saveAct)
                    this.modalEvent(false)
            },
            onCancel: function(){
                this.saveState(false)
                if(!this.saveAct)
                    this.modalEvent(false)
            },
            saveState: function(val){
                this.saveAct = val
            },
            changeData(val, name){
                this.modalProps[name] = val
            },
            changeDisabled(val){
                if(val == this.modalProps.name)
                    this.disabled = false
            },
            // Modal tamamlandığı zaman olacak event
            saveModal: async function(bvModalEvt){
                bvModalEvt.preventDefault()
                // Modalın içerisindeki watchı tetikler
                await this.saveState(true)
                if(this.$store.getters.getStatus.status == "Success"){
                    this.$store.dispatch(this.form+'_list')
                }
            }
            
        },
        watch:{
            saveAct(){
                
                return false
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/General/Defination/modals/index.vue